import type { Direction } from '../types';

export class MovementCommandQueue {
  private queued?: { direction: Direction; expiresAt: number };

  constructor(private readonly bufferMs = 260) {}

  request(direction: Direction, now: number): void {
    this.queued = { direction, expiresAt: now + this.bufferMs };
  }

  peek(now: number): Direction | undefined {
    if (this.queued && now <= this.queued.expiresAt) return this.queued.direction;
    this.queued = undefined;
    return undefined;
  }

  consume(now: number): Direction | undefined {
    const direction = this.peek(now);
    if (direction) this.queued = undefined;
    return direction;
  }

  clear(): void {
    this.queued = undefined;
  }
}
